import { PatternFormat } from 'react-number-format';
import { Input, type InputProps } from '../ui';

const PhoneNumberInput = ({ className, type, ...props }: InputProps) => {
  return (
    <PatternFormat
      {...props}
      getInputRef={() => props.ref}
      format={
        String(props.value)?.length > 10
          ? '+# (###) ###-####'
          : '(###) ###-####'
      }
      customInput={Input}
      value={String(props.value)}
      onChange={props.onChange}
      inputMode="tel"
      defaultValue={String(props.defaultValue)}
    />
  );
};

export default PhoneNumberInput;
